const AttributeChip = ({ children, className, style, value }) => {
  return (
    <div style={style} className={`attribute-chip mdl-chip ${className}`}>
      {children || value}
    </div>
  )
}

export default AttributeChip
